export class AppConsts {
    static IsDefaultFormatDate = true;
    static DefaultFormatDate = 'DD/MM/YYYY';
    static readonly tenancyNamePlaceHolderInUrl = '{TENANCY_NAME}';

  static remoteServiceBaseUrl: string;
  //CE-1395
  static remoteServiceBaseUrlNew: string;
  static apiGatewayPartnerPrefix: string;
  static hrmPrefix: string;
  static requestPrefix: string;
  static apiGatewayCampaignPrefix: string;
  //CE-1679
  static warehousePrefix: string;
  static partnerUrlFile: string;
  static warehouseUrlFile: string;
  static campaignUrlFile: string;
  static MDUrlFile: string;
  //CE-2040
  static MDPrefix: string;

    static remoteServiceBaseUrlFormat: string;
    static appBaseUrl: string;
    static appBaseHref: string; // returns angular's base-href parameter value if used during the publish
    static appBaseUrlFormat: string;
    static recaptchaSiteKey: string;
    static subscriptionExpireNootifyDayCount: number;

    static localeMappings: any = [];

    static readonly userManagement = {
        defaultAdminUserName: 'admin',
    };

    static readonly localization = {
        defaultLocalizationSourceName: 'SaaS',
    };

    static readonly authorization = {
        encrptedAuthTokenName: 'enc_auth_token',
        newAccessToken: 'new_access_token'
    };

    static readonly grid = {
        defaultPageSize: 10,
    };

    static readonly CriteriaConsts = {
        Rank: 'Rank',
        RankType: 'RankType',
        Region: 'Region',
        SalesRegion: 'SalesRegion',
        Customer: 'Customer',
        SecondaryCustomerType: 'SecondaryCustomerType',
        ChannelType: 'ChannelType',
        Product: 'Product',
        Department: 'Department',
        Class: 'Class',
        ProfileCode: 'ProfileCode',
    };

    static readonly FormatDate = {
        ShortDate: [
            {
                locale: 'vi',
                display: 'dd/MM/yyyy',
            },
            {
                locale: 'en',
                display: 'MM/dd/yyyy',
            },
        ],
        LongDate: [
            {
                locale: 'vi',
                display: 'dd/MM/yyyy, HH:mm:ss',
            },
            {
                locale: 'en',
                display: 'MM/dd/yyyy, HH:mm:ss',
            },
        ],
        VNShortDate: 'dd/MM/yyyy',
        USShortDate: 'MM/dd/yyyy',
        VNShort: 'dd/MM/yyyy, HH:mm',
        USShort: 'MM/dd/yyyy, HH:mm',
        USShortTime: 'MM/dd/yyyy, HH:mm:ss',
        VNShortTime: 'dd/MM/yyyy, HH:mm:ss',
    };

    static readonly cron = {
        day: '0 0 * * *',
        week: '0 0 * * 0',
        month: '0 0 1 * *',
        year: '0 0 1 1 *',
    };

    static DatePeriod = {
        Monthly: 'Monthly',
        Yearly: 'Yearly',
        Quaterly: 'Quaterly',
        Export: 'Export',
    };

  static OutletTypeConsts = {
    MemberShop: 'MemberShop',
    Distributor: 'Distributor',
    VipShop: 'VipShop',
    Activator: 'Activator',
    ALL: 'DistributorSellthru,VipShopSellthru,MemberShop,PotentialRetailer,OfficalRetailer,Activator,BrandShop,TechShop',
    BrandShop: 'BrandShop',
    TechShop: 'TechShop'
  };

    static SalesTypeConst = {
        SELLIN: 'SellIn',
        SELLOUT: 'SellOut',
        INTERNALTRANSFER: 'InternalTransfer',
        SOLDTOCUSTOMER: 'SoldtoCustomer',
        SOLDTORETAILER: 'SoldtoRetailer',
        SOLDTODISTRIBUTOR: 'SoldtoDistributor',
        TRANSFER: 'Transfer',
        DISTRIBUTORSELLTHRU: 'DistributorSellthru',
        VIPSHOPSELLTHRU: 'VipShopSellthru',
        BRANDSHOPSELLTHRU: 'BrandShopSellthru',
        TECHSHOPSELLTHRU: 'TechShopSellthru'
    }

    static TemplateTypes = {
        SellVipShopPaymentImport: 'SellVipShopPaymentImport',
        SellVipShopImport: 'SellVipShopImport',

        SellThruPaymentImport: 'SellThruPaymentImport',
        SellThruImport: 'SellThruImport',
    }

    static TemplateDownload = {
        ExtendActiveTemplate: 'ExtendActiveTemplate',
        ActivationCode: 'ActivationCode'
    }

    static ImportType = {
        ExtendActive: 'ExtendActive',
        SellOutDistribute: 'SellOutDistribute',
        SellOutDistributeReturn: 'SellOutDistributeReturn',
        ActivationCode: 'ActivationCode',
        ActivationCodeUpdate: 'ActivationCodeUpdate',
        SellIn: 'SellIn',
        SellInPayment: 'SellInPayment',
        SellOutImport: 'SellOutImport',
        SellOutPaymentImport: 'SellOutPaymentImport',
        WarrantySerial: 'WarrantySerial',
        ExtendActiveImport: 'ExtendActiveImport',
        SaleInsertSerialAll: 'SaleInsertSerialAll',
        SellThruImport: 'SellThruImport',
        SellThruPaymentImport: 'SellThruPaymentImport',
        SellVipShopImport: 'SellVipShopImport',
        SellVipShopPaymentImport: 'SellVipShopPaymentImport',
        SerialTypeImport: 'SerialTypeImport',
        SerialManufacture: 'SerialManufacture',
    }

    /**
     * Constants cho các masterCodeFilter sử dụng trong MasterDetailService
     */
    static readonly MasterCodeFilters = {
        StoreType: 'StoreType',
        ProductHierarchy: 'ProductHierarchy',
        BankList: 'BankList'
    };

    /**
     * Cấu hình mapping giữa outletType và danh sách field tương ứng của OutletExtraInfo
     */
    static readonly OutletTypeFieldMapping: { [key: string]: string[] } = {
        [AppConsts.OutletTypeConsts.BrandShop]: ["storeFrontWidth", "storeRoadWidth", "airOutput12M", "activeYear"],
        [AppConsts.OutletTypeConsts.VipShop]: ["activeYear", "storageSquare", "vehicleCountOver3W", "revenuePreY", "airOutput6M"],
        [AppConsts.OutletTypeConsts.MemberShop]: ["activeYear", "storageSquare", "vehicleCountOver3W", "revenuePreY", "airOutput6M"],
        [AppConsts.OutletTypeConsts.Activator]: ["setupImage"]
    };

    /**
     * Danh sách tất cả các field của OutletExtraInfo
     */
    static readonly AllOutletExtraInfoFields: string[] = [
        "storeFrontWidth",
        "storeRoadWidth",
        "airOutput12M",
        "activeYear",
        "storageSquare",
        "vehicleCountOver3W",
        "revenuePreY",
        "airOutput6M"
    ];
    static readonly Brands = [
        {
            Code: "Casper",
            Name: "Casper",
            Logo: "logo-ecasper.png",
            Order: 1,
        },
        {
            Code: "Electrolux",
            Name: "Electrolux",
            Logo: "logo-electrolux.png",
            Order: 2,
        },
        {
            Code: "Lenson",
            Name: "Lenson",
            Logo: "logo-lenson.png",
            Order: 3,
        }
    ];
    static readonly BrandConsts = {
        Casper: {
            Code: "Casper",
            Name: "Casper",
            Logo: "logo-ecasper.png",
            Order: 1,
        },
        Electrolux: {
            Code: "Electrolux",
            Name: "Electrolux",
            Logo: "logo-electrolux.png",
            Order: 2,
        },
        Lenson: {
            Code: "Lenson",
            Name: "Lenson",
            Logo: "logo-lenson.png",
            Order: 3,
        }
    };
}
